module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('field', {
    attrs: {
      "label": _vm.$t(_vm.label),
      "required": _vm.required,
      "classes": _vm.classes,
      "collection": _vm.statuses,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "type": "radio"
    },
    model: {
      value: (_vm.newValue),
      callback: function($$v) {
        _vm.newValue = $$v
      },
      expression: "newValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659e0f38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/UserStatusSelect.vue
// module id = 1925
// module chunks = 0